export class NinthWaveProps {
  ninthWaveTokenString: string


  constructor(
    ninthWaveTokenString?: string,
    ) {

    this.ninthWaveTokenString = ninthWaveTokenString
  }



}
